import React, { useEffect, useState } from "react";
import healthAuthImg from "../../assets/images/service/healthauth.png";
import HealthDescription1 from "./HealthDescription1";
import TestApiModal from "../../component/modal/TestApiModal";
import TestAPiMobileModal from "../../component/modal/TestApiMobileModal";
import { getCookie } from "../../util/Cookie";
import { TokenName, handleModalController } from "../../util/Common";
import LoginModal from "../../component/modal/LoginModal";

const HealthService1 = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [isLoginModal, setLoginModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    handleModalController({
      windowWidth,
      setShowModal,
      setShowMobileModal,
      setLoginModal,
    });
  };

  return (
    <>
      <div
        className="row sercice-details-content pb--80 align-items-center"
        id="health-1"
      >
        <div className="col-lg-6 col-12">
          <div className="thumb">
            <img className="w-100" src={healthAuthImg} alt="Service Images" />
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="details mt_md--30 mt_sm--30">
            <h4 className="title">건강보험공단 간편인증 API</h4>
            <p>
              건강보험공단 로그인 시 네이버, 카카오 간편인증을 통해 로그인이
              가능하도록 인증을 요청할 수 있습니다.
            </p>

            <ul className="liststyle mt-4">
              <li>
                건강보험공단 로그인 시 간편인증 로그인에 사용되는 네이버/카카오
                간편인증을 지원
              </li>
              <li>건강보험공단에서 로그인 시 제공되는 기능들을 활용 가능</li>
              <li>이름, 휴대폰 번호, 생년월일 입력 필요</li>
            </ul>
          </div>
          <div className="slide-btn mt-4" style={{ cursor: `pointer` }}>
            <a
              className="rn-button-style--2 btn-primary-color"
              onClick={() => handleClick()}
            >
              신청하기
            </a>
          </div>
          {/* <div style={{ marginTop: `20px` }}>
            <button onClick={() => handleModalControler()}>TestButton</button>
          </div> */}
        </div>
      </div>
      <HealthDescription1></HealthDescription1>
      <TestApiModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <TestAPiMobileModal
        isOpen={showMobileModal}
        onClose={() => setShowMobileModal(false)}
      />
      <LoginModal isOpen={isLoginModal} onClose={() => setLoginModal(false)} />
    </>
  );
};
export default HealthService1;
